const getProductUserData = (
  loggedUser: any,
  entityId: number,
  subscriptionAllowed: string,
  type: "lecture" | "program" | "stream" | "nft" | "merch"
) => {
  if (!loggedUser) {
    return { isPaid: false, inCart: false, activeTrialSubscription: false };
  }

  if (loggedUser) {
    // is product in cart
    const sortedOrders = loggedUser.orders.sort(
      (a: { id: number }, b: { id: number }) => {
        return b.id - a.id;
      }
    );

    const order = sortedOrders.find(
      (item: { ip: string }) => item.ip !== "auto"
    );

    const inCart =
      order?.status === "new"
        ? order.order_items.some(
            (item: { entity_id: number; entity_type: string }) =>
              entityId === item.entity_id && item.entity_type === type
          )
        : false;

    // classic payment
    const regularPayment = loggedUser.products.some(
      (item: { entity_id: number; entity: string }) =>
        entityId === item.entity_id && item.entity === type
    );

    // subscription
    const today = new Date();
    const subscriptionTill = new Date(loggedUser.subscription_till);
    const trialSubscriptionTill = new Date(loggedUser.subs_trial_till);
    const isTrialAllowed = subscriptionAllowed === "no_trial";

    // subscription - no_trial
    const trial =
      isTrialAllowed &&
      today > trialSubscriptionTill &&
      today <= subscriptionTill
        ? true
        : false;

    // subscription - full
    const full = !isTrialAllowed && subscriptionTill >= today;

    // active trial subscription for "Try subscription" button
    const activeTrialSubscription =
      isTrialAllowed && trialSubscriptionTill >= today;

    // result of payments
    const isPaid = regularPayment || trial || full;

    return { isPaid, inCart, activeTrialSubscription };
  }
};

export default getProductUserData;
